var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_1297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8045 5.40959L11.8363 0.231859C11.6368 0.116703 11.3912 0.116746 11.1918 0.231859L2.22363 5.40959C2.02421 5.52471 1.90137 5.73749 1.90137 5.96776V16.3232C1.90137 16.5535 2.02421 16.7663 2.22363 16.8814L11.1918 22.0591C11.2915 22.1167 11.4028 22.1455 11.5141 22.1455C11.6253 22.1455 11.7366 22.1167 11.8363 22.0591L20.8046 16.8814C21.004 16.7663 21.1268 16.5535 21.1268 16.3232V5.96776C21.1268 5.73749 21.0039 5.52471 20.8045 5.40959ZM19.6067 6.20649L17.4995 9.85643L13.2849 2.55664L19.6067 6.20649ZM9.75326 19.7401L3.42637 16.0873L5.53549 12.4346L9.75326 19.7401ZM3.42637 6.20366L9.75326 2.55084L5.53549 9.85643L3.42637 6.20366ZM6.65186 11.79H16.3803L11.5143 20.2122L6.65186 11.79ZM6.65186 10.501L11.5174 2.07337L16.3832 10.501H6.65186ZM4.79127 11.1455L3.19043 13.918V8.37302L4.79127 11.1455ZM17.4995 12.4346L19.6067 16.0845L13.2849 19.7344L17.4995 12.4346ZM18.2438 11.1455L19.8377 8.38458V13.9064L18.2438 11.1455Z",
    fill: "#08A9E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_1297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.513672 0.145508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/Dice.a708c1d5458c665aa03a003e5b24e068.svg";
export { ForwardRef as ReactComponent };